import { z } from 'zod';
import type { DeepUndefinedOrNull } from '@/types/partial';
import {
    ProdutoAdicionalOrdenacao,
    ProdutoAdicionalStatus,
    ProdutoAdicionalTipoPreco,
    ProdutoAdicionalTipoSelecao,
} from './enum';

export const ProdutoAdicionalSchema = z.object({
    pra_data_insercao: z.string(),
    pra_detalhes: z.string().nullable(),
    pra_empresa_idpk: z.number(),
    pra_idpk: z.string(),
    pra_nome: z.string(),
    pra_obrigatorio: z.enum(['S', 'N']),
    pra_ordenacao: z.enum(ProdutoAdicionalOrdenacao),
    pra_quantidade_maxima: z.number(),
    pra_quantidade_minima: z.number(),
    pra_status: z.enum(ProdutoAdicionalStatus),
    pra_tipo_preco: z.enum(ProdutoAdicionalTipoPreco),
    pra_tipo_selecao: z.enum(ProdutoAdicionalTipoSelecao),
    pra_ultima_alteracao: z.string().nullable(),
});

export type ProdutoAdicional = z.infer<typeof ProdutoAdicionalSchema>;

export type ProdutoAdicionalBody = DeepUndefinedOrNull<ProdutoAdicional>;
